export default {
  pressArticlesIsLoading: false,
  pressArticlesList: [],
  pressArticlesLanguageFilters: [],
  pressArticlesCategoryFilters: [],
  pressArticlesActiveFilters: {},
};
